interface DateFormatProps {
  date?: string | null;
  locale?: string;
  options?: Intl.DateTimeFormatOptions;
}

interface GetTimezoneProps {
  userTimezone: string | null | undefined;
}

const FORMAT_FULL_DATE: Intl.DateTimeFormatOptions = {
  dateStyle: 'long',
};

const FORMAT_FULL_DATETIME: Intl.DateTimeFormatOptions = {
  dateStyle: 'long',
  timeStyle: 'short',
};

const format = ({
  date,
  locale = window.__HB_LOCALE__ || 'en-US',
  options = {},
}: DateFormatProps) => {
  if (!date) {
    return '-';
  }

  let dateObj: Date;

  try {
    dateObj = new Date(date);
  } catch (e) {
    throw new RangeError(e);
  }

  return new Intl.DateTimeFormat(locale, options).format(dateObj);
};

const formatUTC = ({
  date,
  locale = window.__HB_LOCALE__ || 'en-US',
  options = {},
}: DateFormatProps) =>
  format({ date, locale, options: { ...options, timeZone: 'UTC' } });

const getTimezone = (
  { userTimezone }: GetTimezoneProps = { userTimezone: undefined },
) => userTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

const dateToUnix = (date: Date) => Math.floor(date.getTime() / 1000);

export {
  dateToUnix,
  format,
  FORMAT_FULL_DATE,
  FORMAT_FULL_DATETIME,
  formatUTC,
  getTimezone,
};
